import { optionsSelector, departureCitySelector } from 'app/store/selectors';
import { AutocompleteResult } from 'app/models/types/store/location';
import { fetchPopularCities } from 'app/providers';
import { setPopularCities } from 'app/store/reducers/location';
import { ThunkType } from 'app/hooks/appHooks';
import { SearchMaskDirection } from 'app/models/types/store/location';

export type LoadPopularCitiesType = {
  direction: SearchMaskDirection;
};

export const loadPopularCities =
  ({ direction }: LoadPopularCitiesType): ThunkType<void> =>
  async (dispatch, getState) => {
    const state = getState();
    let popularCities: AutocompleteResult[] = [];
    const departure = departureCitySelector(state);
    const { locale, citiesDetailsEndpoint, recommendationUrl } = optionsSelector(state);

    try {
      popularCities = await fetchPopularCities(
        recommendationUrl,
        citiesDetailsEndpoint,
        locale,
        direction === 'to' ? departure.uuid : undefined,
      );
    } catch (e) {
      popularCities = [];
    }

    dispatch(setPopularCities({ popularCities, direction }));
  };
